"use strict";
var promptparse = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // src/validate/index.ts
  var validate_exports = {};
  __export(validate_exports, {
    anyId: () => anyId,
    bcelOneProof: () => bcelOneProof,
    billPayment: () => billPayment2,
    slipVerify: () => slipVerify,
    trueMoneySlipVerify: () => trueMoneySlipVerify
  });

  // src/utils/checksum.ts
  var TABLE = [
    0,
    4129,
    8258,
    12387,
    16516,
    20645,
    24774,
    28903,
    33032,
    37161,
    41290,
    45419,
    49548,
    53677,
    57806,
    61935,
    4657,
    528,
    12915,
    8786,
    21173,
    17044,
    29431,
    25302,
    37689,
    33560,
    45947,
    41818,
    54205,
    50076,
    62463,
    58334,
    9314,
    13379,
    1056,
    5121,
    25830,
    29895,
    17572,
    21637,
    42346,
    46411,
    34088,
    38153,
    58862,
    62927,
    50604,
    54669,
    13907,
    9842,
    5649,
    1584,
    30423,
    26358,
    22165,
    18100,
    46939,
    42874,
    38681,
    34616,
    63455,
    59390,
    55197,
    51132,
    18628,
    22757,
    26758,
    30887,
    2112,
    6241,
    10242,
    14371,
    51660,
    55789,
    59790,
    63919,
    35144,
    39273,
    43274,
    47403,
    23285,
    19156,
    31415,
    27286,
    6769,
    2640,
    14899,
    10770,
    56317,
    52188,
    64447,
    60318,
    39801,
    35672,
    47931,
    43802,
    27814,
    31879,
    19684,
    23749,
    11298,
    15363,
    3168,
    7233,
    60846,
    64911,
    52716,
    56781,
    44330,
    48395,
    36200,
    40265,
    32407,
    28342,
    24277,
    20212,
    15891,
    11826,
    7761,
    3696,
    65439,
    61374,
    57309,
    53244,
    48923,
    44858,
    40793,
    36728,
    37256,
    33193,
    45514,
    41451,
    53516,
    49453,
    61774,
    57711,
    4224,
    161,
    12482,
    8419,
    20484,
    16421,
    28742,
    24679,
    33721,
    37784,
    41979,
    46042,
    49981,
    54044,
    58239,
    62302,
    689,
    4752,
    8947,
    13010,
    16949,
    21012,
    25207,
    29270,
    46570,
    42443,
    38312,
    34185,
    62830,
    58703,
    54572,
    50445,
    13538,
    9411,
    5280,
    1153,
    29798,
    25671,
    21540,
    17413,
    42971,
    47098,
    34713,
    38840,
    59231,
    63358,
    50973,
    55100,
    9939,
    14066,
    1681,
    5808,
    26199,
    30326,
    17941,
    22068,
    55628,
    51565,
    63758,
    59695,
    39368,
    35305,
    47498,
    43435,
    22596,
    18533,
    30726,
    26663,
    6336,
    2273,
    14466,
    10403,
    52093,
    56156,
    60223,
    64286,
    35833,
    39896,
    43963,
    48026,
    19061,
    23124,
    27191,
    31254,
    2801,
    6864,
    10931,
    14994,
    64814,
    60687,
    56684,
    52557,
    48554,
    44427,
    40424,
    36297,
    31782,
    27655,
    23652,
    19525,
    15522,
    11395,
    7392,
    3265,
    61215,
    65342,
    53085,
    57212,
    44955,
    49082,
    36825,
    40952,
    28183,
    32310,
    20053,
    24180,
    11923,
    16050,
    3793,
    7920
  ];
  function crc16xmodem(data, crc = 0) {
    for (const i of data) {
      const b = i.charCodeAt(0);
      const n = (b ^ crc >> 8) & 255;
      crc = TABLE[n] ^ crc << 8;
    }
    return (crc ^ 0) & 65535;
  }

  // src/lib/tlv.ts
  function decode(payload) {
    const tags = [];
    let idx = 0;
    while (idx < payload.length) {
      const data = payload.substring(idx);
      const id = data.substring(0, 2);
      const length = parseInt(data.substring(2, 4));
      const value = data.substring(4, 4 + length);
      tags.push({ id, length, value });
      idx += length + 4;
    }
    return tags;
  }
  function encode(tags) {
    let payload = "";
    for (const tag2 of tags) {
      payload += tag2.id;
      payload += ("00" + tag2.length).slice(-2);
      if (tag2.subTags) {
        payload += encode(tag2.subTags);
        continue;
      }
      payload += tag2.value;
    }
    return payload;
  }
  function checksum(payload, upperCase = true) {
    let sum = crc16xmodem(payload, 65535).toString(16);
    sum = upperCase ? sum.toUpperCase() : sum.toLowerCase();
    sum = ("0000" + sum).slice(-4);
    return sum;
  }
  function withCrcTag(payload, crcTagId, upperCase = true) {
    payload += ("00" + crcTagId).slice(-2);
    payload += "04";
    payload += checksum(payload, upperCase);
    return payload;
  }
  function get(tlvTags, tagId, subTagId) {
    const tag2 = tlvTags.find((t) => t.id == tagId);
    if (subTagId) {
      return tag2?.subTags?.find((s) => s.id == subTagId);
    }
    return tag2;
  }

  // src/lib/EMVCoQR.ts
  var EMVCoQR = class {
    constructor(payload, tags) {
      __publicField(this, "payload");
      __publicField(this, "tags");
      this.payload = payload;
      this.tags = tags;
    }
    getTag(tagId, subTagId) {
      return get(this.tags, tagId, subTagId);
    }
    getTagValue(tagId, subTagId) {
      return this.getTag(tagId, subTagId)?.value;
    }
    getTags() {
      return this.tags;
    }
    /* c8 ignore next 3 */
    getPayload() {
      return this.payload;
    }
    validate(crcTagId) {
      const tags = [...this.tags].filter((f) => f.id != crcTagId);
      const expected = withCrcTag(encode(tags), crcTagId);
      return this.payload === expected;
    }
  };

  // src/lib/parser.ts
  function parse(payload, strict = false, subTags = true) {
    if (!payload.match(/^\d{4}.+/)) {
      return null;
    }
    if (strict) {
      const expected = payload.slice(-4).toUpperCase();
      const calculated = checksum(payload.slice(0, -4));
      if (expected != calculated) return null;
    }
    const tags = decode(payload);
    if (tags.length == 0) {
      return null;
    }
    if (subTags) {
      for (const tag2 of tags) {
        if (typeof tag2.value !== "string" || !tag2.value.match(/^\d{4}.+/)) {
          continue;
        }
        const sub = decode(tag2.value);
        if (sub.every((val) => val.length > 0 && val.length === val.value.length)) {
          tag2.subTags = sub;
        }
      }
    }
    return new EMVCoQR(payload, tags);
  }

  // src/validate/bcel/BCELOneProof.ts
  function bcelOneProof(payload) {
    const ppqr = parse(payload, true);
    const type = ppqr?.getTagValue("33", "02");
    const ticket = ppqr?.getTagValue("33", "03");
    const fccref = ppqr?.getTagValue("33", "04");
    if (ppqr?.getTagValue("00") !== "01" && ppqr?.getTagValue("01") !== "11" && ppqr?.getTagValue("33", "00") !== "BCEL" && ppqr?.getTagValue("33", "00") !== "ONEPROOF") {
      return null;
    }
    return {
      type,
      ticket,
      fccref
    };
  }

  // src/generate/promptpay/AnyID.ts
  var ProxyType = /* @__PURE__ */ ((ProxyType2) => {
    ProxyType2["MSISDN"] = "01";
    ProxyType2["NATID"] = "02";
    ProxyType2["EWALLETID"] = "03";
    ProxyType2["BANKACC"] = "04";
    return ProxyType2;
  })(ProxyType || {});

  // src/validate/promptpay/AnyID.ts
  function anyId(payload) {
    const ppqr = parse(payload, true);
    const aidType = ppqr?.getTagValue("00");
    const tag29Aid = ppqr?.getTagValue("29", "00");
    if (aidType !== "01" || tag29Aid !== "A000000677010111") {
      return null;
    }
    const proxyTypeEntry = Object.entries(ProxyType).find(([, id]) => ppqr?.getTagValue("29", id) !== void 0);
    if (!proxyTypeEntry) {
      return null;
    }
    const [type, subTagId] = proxyTypeEntry;
    let target = ppqr.getTagValue("29", subTagId);
    if (type === "MSISDN" && target.length == 13 && target.startsWith("0066")) {
      target = "0" + target.slice(-9);
    }
    const amountStr = ppqr?.getTagValue("54");
    const amount = amountStr !== void 0 ? parseFloat(amountStr) : void 0;
    return {
      type,
      target,
      ...amount !== void 0 && { amount }
    };
  }

  // src/validate/promptpay/BillPayment.ts
  function billPayment2(payload) {
    const ppqr = parse(payload, true);
    const aidType = ppqr?.getTagValue("00");
    const tag30Aid = ppqr?.getTagValue("30", "00");
    const billerId = ppqr?.getTagValue("30", "01");
    const ref1 = ppqr?.getTagValue("30", "02");
    if (aidType !== "01" || tag30Aid !== "A000000677010112" || !billerId || !ref1) {
      return null;
    }
    const ref2 = ppqr?.getTagValue("30", "03");
    const ref3 = ppqr?.getTagValue("62", "07");
    const amountStr = ppqr?.getTagValue("54");
    const amount = amountStr !== void 0 ? parseFloat(amountStr) : void 0;
    return {
      billerId,
      ref1,
      ...ref2 !== void 0 && { ref2 },
      ...ref3 !== void 0 && { ref3 },
      ...amount !== void 0 && { amount }
    };
  }

  // src/validate/promptpay/SlipVerify.ts
  function slipVerify(payload, crcAutoFix = true) {
    if (crcAutoFix) {
      const idx = payload.lastIndexOf("9104");
      if (idx != -1) {
        const crc = payload.substring(idx + 4);
        if (crc.length > 0 && crc.length < 4) {
          payload = payload.substring(0, idx + 4) + crc.padStart(4, "0");
        }
      }
    }
    const ppqr = parse(payload, true);
    const apiType = ppqr?.getTagValue("00", "00");
    const sendingBank = ppqr?.getTagValue("00", "01");
    const transRef = ppqr?.getTagValue("00", "02");
    if (apiType !== "000001" || !sendingBank || !transRef) {
      return null;
    }
    return {
      sendingBank,
      transRef
    };
  }

  // src/validate/truemoney/TrueMoneySlipVerify.ts
  function trueMoneySlipVerify(payload) {
    const ppqr = parse(payload, true);
    const eventType = ppqr?.getTagValue("00", "02");
    const transactionId = ppqr?.getTagValue("00", "03");
    const date = ppqr?.getTagValue("00", "04");
    if (ppqr?.getTagValue("00", "00") !== "01" && ppqr?.getTagValue("00", "01") !== "01") {
      return null;
    }
    return {
      eventType,
      transactionId,
      date
    };
  }
  return __toCommonJS(validate_exports);
})();
